import { Field as FinalFormField, FieldProps, FieldRenderProps } from 'react-final-form'
import React from 'react'

const identity = (value: any) => value

/* This wraps react-final-form's <Field/> component.
 * The identity function ensures form values never get set to null,
 * but rather, empty strings.
 *
 * See https://github.com/final-form/react-final-form/issues/130
 */
export const Field = (props: FieldProps<any, FieldRenderProps<any>>) => (
  <FinalFormField parse={identity} {...props} />
)
